@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';

.container {
  display: grid;
  row-gap: 8px;
}

.label {
  font-weight: 400;
  font-size: 12px;
}

.expiration-row {
  display: flex;
  width: 100%;
}

.error-prompt {
  display: flex;
  height: 24px;
  border-radius: 2px;
  background: @credit-card--error-prompt--background-color;
  font-size: 12px;
  line-height: 16px;
  padding: 4px;

  .error-icon {
    height: 16px;
    color: @credit-card--error-prompt--text-color;
    margin-right: 4px;
  }
}
